export const comments_5256810 = {"data":{"data":[],"links":{}}}